import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
    import { useRouter } from 'vue-router/composables';
    import { ToastProgrammatic as Toast } from 'buefy';
    import THGUserForm from '@/components/thg/user/THGUserForm.vue';
    import { THGUser } from '@/interfaces/thg/THGUser';
    import { THGUserType } from '@/enums/thg/THGUserType';
    import { addTHGUser } from '@/api/thg/users';
    import { createTHGUserCreateData } from '@/utils/thg';
    import { alertError } from '@/utils/dialogs';
    import emitter from '@/utils/mitt';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'NewTHGUser',
  setup(__props) {

    const router = useRouter();

    // the display-only fields (id, deletable, counts,...) are placeholders, they're not sent to the api
    const newUser = ref<THGUser>({
        id: '',
        email: '',
        is_verified: true,
        is_active: true,
        type: THGUserType.PRIVATE,
        first_name: null,
        last_name: null,
        phone_number: null,
        street: null,
        zip_code: null,
        city: null,
        donation_ratio: 0,
        donation_projects: [],
        payee: null,
        iban: null,
        deletable: true,
        total_cars_count: 0,
        cars_count: 0,
        registration_limit: 100,
        valid_promotions: {},
        tags: [],
    });

    async function addUser() {
        emitter.emit('showLoader');

        const response = await addTHGUser(createTHGUserCreateData(newUser.value));

        emitter.emit('hideLoader');

        if (response.status === 201 && response.parsedBody?.user_id) {
            Toast.open({ type: 'is-success', message: 'User erfolgreich angelegt.' });
            router.push({ name: 'thguser', params: { userId: response.parsedBody.user_id } });
        } else if (response.status === 409) {
            alertError(
                'Fehler',
                `Ein User mit der E-Mail-Adresse <b>${newUser.value.email}</b> existiert bereits.`,
            );
        } else {
            alertError('Fehler', 'Fehler beim Anlegen des Users.');
        }
    }

return { __sfc: true,router, newUser, addUser, THGUserForm }
}

})